export default {
    bindings: {
        order: '<',
        formTab: '='
    },
    controller: 'orderEmailsController',
    template: require('../views/order.emails.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.emails.component.js